import { render, staticRenderFns } from "./ArtworkEditModal.vue?vue&type=template&id=af360fa2"
import script from "./ArtworkEditModal.vue?vue&type=script&lang=js"
export * from "./ArtworkEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports